export default __webpack_public_path__ + "4751e9170b3b258928e564df8edef0a5.png";